import ListSelectorConnector from './listSelector.props';
import ListSelectorComponent from './listSelector.component';

export default ListSelectorConnector(ListSelectorComponent);
